import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const HeaderV2 = dynamic(() => import('./'));

export const defaultOptions = {
	copy: '<p>TOTAL INJURY HELP</p>',
	logo: {
		'@type': '@builder.io/core:Reference',
		id: '8cb20d37a5444699a3050b4a5d527ace',
		model: 'header-logo',
	},
	logoHeight: 45,
	usePageColors: true,
	backgroundColor: '#FFF',
	textColor: '#475569',
	textSize: 13,
	showMobileLogo: true,
	showMobileText: true,
} as const;

Builder.registerComponent(HeaderV2, {
	name: 'HeaderV2',
	inputs: [
		{
			name: 'copy',
			friendlyName: 'Heading',
			type: 'richText',
			required: true,
			defaultValue: defaultOptions.copy,
		},
		{
			name: 'logo',
			friendlyName: 'Logo',
			type: 'reference',
			model: 'header-logo',
			defaultValue: defaultOptions.logo,
		},
		{
			name: 'logoHeight',
			friendlyName: 'Logo Height',
			type: 'number',
			defaultValue: defaultOptions.logoHeight,
			helperText: 'Height of the logo in pixels',
			min: 0,
			max: 100,
			showIf: function (options) {
				return options.get('logo') !== null;
			},
		},
		{
			name: 'usePageColors',
			friendlyName: 'Use Page Colors',
			type: 'boolean',
			defaultValue: defaultOptions.usePageColors,
			helperText: `If true, will use colors set on page for styling;
			if false, use the controls below`,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.backgroundColor,
			helperText: 'Be sure to select a color light or dark enough for the text to have contrast',

			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
		{
			name: 'textColor',
			friendlyName: 'Text Color',
			type: 'color',
			defaultValue: defaultOptions.textColor,
			helperText: 'Be sure to select a color light or dark enough for the text to have contrast',

			showIf: function (options) {
				return options.get('usePageColors') === false;
			},
		},
		{
			name: 'textSize',
			friendlyName: 'Text Size',
			type: 'number',
			defaultValue: defaultOptions.textSize,
			helperText: 'Font size for the header text. Enter a value in pixels',
		},
		{
			name: 'showMobileLogo',
			friendlyName: 'Show Mobile Logo',
			type: 'boolean',
			defaultValue: defaultOptions.showMobileLogo,
			helperText: 'Should the logo be shown at mobile sizes?',
		},
		{
			name: 'showMobileText',
			friendlyName: 'Show Mobile Text',
			type: 'boolean',
			defaultValue: defaultOptions.showMobileText,
			helperText: `Should text be shown at mobile sizes?
				Will default to mobile text only if none are selected.`,
		},
	],
	image: getIconUrl(Icon.HEADER),
});
